import { useCallback, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import useActivityTracker from "hooks/useActivityTracker";
import useMediaQuery from "hooks/useMediaQuery";

type SmartScoreTooltipProps = {
  children: React.ReactElement;
  tooltip: React.ReactNode | string;
  entity: any;
  name: string;
};

const SmartScoreTooltip = ({
  children,
  tooltip,
  entity,
  name,
}: SmartScoreTooltipProps) => {
  const { mobile } = useMediaQuery();
  const { trackActivity } = useActivityTracker();

  const [show, setShow] = useState(false);
  const [viewed, setViewed] = useState(false);

  const onToggle = useCallback(
    (show) => {
      setShow(show);

      if (show && !viewed) {
        trackActivity("smartscore.view_tooltip", entity, { target: name });
        setViewed(true);
      }
    },
    [entity, name, trackActivity, viewed]
  );

  return (
    <OverlayTrigger
      rootClose
      placement={mobile ? "bottom" : "top"}
      trigger={mobile ? "click" : ["click", "hover"]}
      delay={mobile ? undefined : 300}
      show={show}
      onToggle={onToggle}
      overlay={
        <Tooltip>
          <div className="text-left">{tooltip}</div>
          {mobile && (
            <div
              className={twMerge(
                "border border-solid border-white rounded-lg",
                "px-[10px] py-[5px]",
                "my-[10px]",
                "w-fit"
              )}
              onClick={() => {
                setShow(false);
              }}
            >
              GOT IT
            </div>
          )}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default SmartScoreTooltip;
